import * as React from "react";
import {useState} from "react";
import {
    Box,
    Button,
    Container,
    TextField,
    Typography,
    Paper,
    Alert,
    IconButton,
    InputAdornment,
    CircularProgress,
    FormControlLabel,
    Checkbox
} from "@mui/material";
import {Visibility, VisibilityOff, Login as LoginIcon, Security} from "@mui/icons-material";
import {signIn} from "../api/AiAgentApi";
import axios from "axios";

/**
 * Простая страница авторизации (без регистрации и ссылок)
 * - MUI компоненты
 * - Валидация полей
 * - Показ/скрытие пароля
 * - Отображение ошибок API
 * - Сохранение токенов в localStorage
 * - Установка Authorization заголовка в axios
 */
export default function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!username.trim() || !password) {
            setError("Заполните логин и пароль");
            return;
        }

        setSubmitting(true);
        try {
            const res = await signIn(username.trim(), password);
            const { accessToken, refreshToken: rt } = res.data || {};

            if (!accessToken || !rt) {
                setError("Некорректный ответ сервера: нет токенов")
                return
            }

            const storage = rememberMe ? window.localStorage : window.sessionStorage;
            storage.setItem("accessToken", accessToken);
            storage.setItem("refreshToken", rt);

            axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

            window.location.reload()
        } catch (err) {
            const msg = (err?.response?.data?.message)
                || (err?.response?.status ? `Ошибка ${err.response.status}` : err?.message)
                || "Неизвестная ошибка";
            setError(msg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Container maxWidth="xs" sx={{ display: "grid", placeItems: "center", minHeight: "100dvh" }}>
            <Paper elevation={8} sx={{ p: 4, width: "100%", borderRadius: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                    <Security />
                    <Typography variant="h5" fontWeight={700}>Вход в панель администратора</Typography>
                </Box>

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                )}

                <Box component="form" onSubmit={handleSubmit} noValidate>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Логин"
                        name="username"
                        autoComplete="username"
                        margin="normal"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />

                    <TextField
                        fullWidth
                        label="Пароль"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        autoComplete="current-password"
                        margin="normal"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={showPassword ? "Скрыть пароль" : "Показать пароль"}
                                        onClick={() => setShowPassword((v) => !v)}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff/> : <Visibility/>}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />

                    <FormControlLabel
                        control={<Checkbox checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />}
                        label="Запомнить меня"
                        sx={{ mt: 1 }}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        size="large"
                        variant="contained"
                        startIcon={!submitting ? <LoginIcon/> : null}
                        disabled={submitting}
                        sx={{ mt: 2 }}
                    >
                        {submitting ? <CircularProgress size={24}/> : "Войти"}
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}
